import store from 'store';

export const RESET_TIMER    = '[TIMER] RESET TIMER';
export const TICK_TIMER     = '[TIMER] TICK TIMER';
export const SET_MAX_TIME   = '[TIMER] SET MAX TIME';
export const SET_ON_FINISH  = '[TIMER] SET ON FINISH';

let timer = null;

export function startTimer(maxTime=10, onFinish) {
    return (dispatch) => {
        
        clearInterval(timer);
        timer = setInterval(() => dispatch(tick()), 1000);
        
        dispatch({
            type: RESET_TIMER
        });
        
        dispatch({
            type: SET_MAX_TIME,
            payload: (maxTime * 60) // maxTime in minutes, convert to seconds
        });

        dispatch({
            type: SET_ON_FINISH,
            payload: onFinish
        });
    }
}

export function tick() {
    return (dispatch) => {
        const { timeTaken, maxTime, onFinish } = store.getState().timer;
        
        if (timeTaken >= maxTime && maxTime !== 0) {
            onFinish();
            
            clearInterval(timer);
        } else {
            return dispatch({
                type: TICK_TIMER
            });
        }
    }
}

export function resetTimer() {
    clearInterval(timer);
    return {
        type: RESET_TIMER
    }
}

export function endTimer() {
    return (dispatch) => {
        store.getState().timer.onFinish();
        dispatch(resetTimer());
    }
}


// WEBPACK FOOTER //
// src/main/components/timer/store/actions/timer.actions.js